<template>
  <div>
    <!-- Fundraising Kit -->
    <v-row no-gutters class="px-12 py-6">
      <v-col cols="12">
        <FundraisingKit />
      </v-col>
    </v-row>
    <!-- Payment Reminder-->
    <v-row no-gutters class="px-12 py-6">
      <v-col cols="12">
        <PaymentReminder />
      </v-col>
    </v-row>
    <v-row no-gutters class="px-12 py-6">
      <v-col cols="12">
        <EnableHighRisk />
      </v-col>
    </v-row>
    <!-- Recurrences Service -->
    <v-row no-gutters class="px-12 py-6">
      <v-col cols="12">
        <RecurrencesService />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import EnableHighRisk from './EnableHighRisk.vue'
import FundraisingKit from '@/components/Organization/Features/FundraisingKit'
import PaymentReminder from '@/components/Organization/Features/PaymentReminder'
import RecurrencesService from '@/components/Organization/Features/RecurrencesService'

export default {
  name: 'organizationFeatures',
  components: {
    FundraisingKit,
    PaymentReminder,
    RecurrencesService,
    EnableHighRisk
  }
}
</script>

<style lang="scss" scoped></style>
